import {
  callNative,
  getAppPreference,
  hasNativePlugin,
  setAppPreference,
} from 'helpers/nativeApp';

// @aparajita/capacitor-biometric-auth registers its native side under this name.
const PLUGIN = 'BiometricAuthNative';
const ENABLED_KEY = 'biometric-lock-enabled';

// Re-lock only after this long in the background, so switching apps briefly
// (e.g. to copy an email code) doesn't demand Face ID every time.
export const RELOCK_AFTER_MS = 5 * 60 * 1000;

// BiometryType enum from the plugin.
const BIOMETRY_LABELS = {
  1: 'Touch ID',
  2: 'Face ID',
  3: 'fingerprint',
  4: 'face unlock',
};

export async function checkBiometry() {
  if (!hasNativePlugin(PLUGIN)) return { isAvailable: false };
  try {
    return await callNative(PLUGIN, 'checkBiometry');
  } catch (e) {
    return { isAvailable: false };
  }
}

export function getBiometryLabel(info) {
  return (info && BIOMETRY_LABELS[info.biometryType]) || 'biometrics';
}

export async function isBiometricLockEnabled() {
  return (await getAppPreference(ENABLED_KEY)) === 'true';
}

export function setBiometricLockEnabled(enabled) {
  return setAppPreference(ENABLED_KEY, enabled ? 'true' : 'false');
}

/** Resolves true on success, false on failure or cancel. */
export async function authenticate(reason = 'Unlock Twine') {
  try {
    await callNative(PLUGIN, 'internalAuthenticate', {
      reason,
      cancelTitle: 'Cancel',
      // Device passcode as fallback, so a failed face scan never locks
      // someone out of their account.
      allowDeviceCredential: true,
      androidTitle: 'Unlock Twine',
      androidConfirmationRequired: false,
    });
    return true;
  } catch (e) {
    return false;
  }
}
